
import { Vue, Component } from "vue-property-decorator";
import { uiStore } from "@/store/store-accessor";
import { stopInlineEditing } from "@/lib/inline-editor/inline-editor";

@Component
export default class InlineEditorBackdrop extends Vue {
  get style() {
    if (!this.rect) return null;

    return {
      clipPath: `polygon(
        0% 0%,
        100% 0%,
        100% 100%,
        0% 100%,
        0% ${this.rect?.y}px,
        ${this.rect?.x}px ${this.rect?.y}px,
        ${this.rect?.x}px ${this.rect?.bottom}px,
        ${this.rect?.right}px ${this.rect?.bottom}px,
        ${this.rect?.right}px ${this.rect?.y}px,
        0% ${this.rect?.y}px
      )`
    };
  }

  get shouldShowBackdrop() {
    return (
      uiStore.isInlineEditing && uiStore.inlineEditingContext?.showBackdrop
    );
  }

  get rect() {
    return uiStore.inlineEditingRect;
  }

  onBackdropClick() {
    stopInlineEditing();
  }
}
